// extracted by mini-css-extract-plugin
module.exports = {"tablist":"style_tablist__1ore9","badge":"style_badge__3bNMK","tab_title":"style_tab_title__2Aelc","tabs_wrapper":"style_tabs_wrapper__VXQ2j"};